module.exports = __webpack_public_path__ + "img/peopleOutside.48250ee8.svg";